<template>
  <div>

    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader class="p-1">
            <CRow>
              <CCol col="8" style="text-align: start ;padding:10px 20px 0 20px ">
                <strong >{{$t('supplierFactors')}}</strong>

              </CCol>
              <CCol col="4" style="text-align: end">
                <CButton
                    class="mr-1"
                    size="sm"
                    color="secondary"
                >{{ $t("buttons.print") }}
                </CButton>

              </CCol>
            </CRow>
            <!--        </div>-->

            <!-- Right aligned nav items -->
            <!--      </CCollapse>-->
          </CCardHeader>

          <CCardBody>
              <CRow>
                  <CCol col="3">
                      <CSelect :options="[{label:$i18n.t('all'),value:0},{label:$i18n.t('active'),value:1},{label:$i18n.t('deactivate'),value:2}]"
                               :value.sync="selected_status"
                               :label="$t('tables.status')"
                               horizontal
                      />
                  </CCol>
<!--                <CCol col="3">-->
<!--                      <CSelect-->
<!--                          label="مسیر"-->
<!--                          horizontal-->
<!--                      />-->
<!--                  </CCol>-->
                <CCol col="3">
                  <date-picker
                      :label="$t('components.startDate')"
                      v-model="start_date"></date-picker>
                </CCol>
                <CCol col="3">
                  <date-picker
                      :label="$t('components.endDate')"
                      v-model="end_date"></date-picker>

                </CCol>
              </CRow>
                <CDataTable
                    :items="items_customer"
                    :fields="fields"
                    column-filter
                    @row-clicked="table_row_clicked"
striped
                    border
                    :items-per-page="10"
                    hover
                    sorter
                    pagination
                >
                  <template #row_id="{item}">

                      <td style="text-align: center">
                      <p >{{ item.row_id + 1 }}</p>

                    </td>

                  </template>
                  <template #userName="{item}">

                    <td>
                      <p >{{ item.userName }}</p>

                    </td>

                  </template>


                    <template #title="{item}">
                        <td>
                            <p v-if="item.title!=null" >{{ item.title }}</p>
                        </td>
                    </template>
                    <template #surName="{item}">
                        <td>
                            <p v-if="item.surName!=null" >{{ item.surName }}</p>
                        </td>
                    </template>
                    <template #email="{item}">
                        <td>
                            <p v-if="item.email!=null" >{{ item.email }}</p>
                        </td>
                    </template>
                    <template #jobProfile="{item}">
                        <td>
                            <p v-if="item.jobProfile!=null" >{{ item.jobProfile }}</p>
                        </td>
                    </template>
                    <template #branch="{item}">
                        <td>
                            <p v-if="item.branch!=null" >{{ item.branch }}</p>
                        </td>
                    </template>

                  <template #operation="{item}">
                    <td >
                      <CButton
                          class="m-1"
                          color="primary"
                          variant="outline"
                          square
                          :title="$t('buttons.edit')"

                          size="sm"
                          @click="goEditPerson(item)"
                      >
                        <CIcon name="cil-pencil"/>
                      </CButton>
                      <CButton class="m-1"
                               color="success"
                               variant="outline"
                               square
                               size="sm"
                               :title="$t('buttons.documents')"
                               @click="goToDocuments(item)"
                      >
                        <CIcon name="cil-list-rich"/>
                      </CButton>

                      <CButton class="m-1"
                               color="success"
                               variant="outline"
                               square
                               size="sm"
                               :title="$t('buttons.accountingReport')"
                               @click="goToAccountingReport(item)"
                      >
                        <CIcon name="cil-list"/>
                      </CButton>
                    </td>
                  </template>


                </CDataTable>

          </CCardBody>

        </CCard>
      </CCol>
    </CRow>
    <CModal
        :show.sync="saleMethodModal"
        :no-close-on-backdrop="false"
        :centered="true"
        :title="$t('dialogs.editSaleMethod')"
        size="lg"
        color="dark"
    >
      <CSelect
          :options="method_list"
          :value.sync="selected_method"
          :label="$t('tables.saleMethod')"
      />
      <template #header>
        <h6 class="modal-title">{{ $t('dialogs.editSaleMethod') }}</h6>
        <CButtonClose @click="saleMethodModal = false" class="text-white"/>
      </template>
      <template #footer>
        <CButton @click="edit_person_sale_method(selected_method,selected_person)"
                 color="danger"
        >{{ $t("buttons.edit") }}
        </CButton>
        <CButton
            @click="saleMethodModal = false"
            color="success"
        >{{ $t("buttons.cancel") }}
        </CButton>
      </template>
    </CModal>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';

var items_data = [];


export default {
  name: 'Login',
  data() {
    return {
      confirm_delete_name:"confirm"+new Date().getTime()+"_"+this.$vnode.tag,
      name: '',
      file: '',
      color: '#ffffff',
      previewImage: '',
      selected_template: 0,
      description: '',
      saleMethodModal: false,
      method_list: [],
      selected_method: '',
      selected_person: 0,
        table_clicks: 0,
        table_clicks_timer: null,
      items_customer: items_data.map((item, row_id) => {
          return {...item, row_id}
      }),
      fields: [
        {key: 'row_id', label: this.$t('tables.row'),sorter:false, _style: 'width:5%'},
          {key: 'personCode', label: this.$t('customerCode'), _style: 'width:5%'},

          // {key: 'personCode', label: this.$t('personalNo'), _style: 'width:10%'},
        // {key: 'title', label: this.$t('title'), _style: 'width:5%'},
        {key: 'userName', label: this.$t('name'), _style: 'width:10%'},
        {key: 'surName', label: this.$t('lastName'), _style: 'width:10%'},
        {key: 'mobileNo', label: this.$t('mobile'), _style: 'width:10%'},
        {key: 'route', label: this.$t('route'), _style: 'width:10%'},
        {key: 'balance', label: this.$t('tables.balance'), _style: 'width:10%'},
        // {key: 'operation', label: "", _style: 'width:10%'},
      ],
      start_date: '',
      end_date: '',

      details: [],

      collapseDuration: 0,
        selected_status:0,

        status_form: 0
    }
  }, mounted() {
    this.start_date = this.get_day_before_today(1);
    this.end_date = this.get_today();

    this.$root.root_validate_errors = [];
    this.get_method_lists();

    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  }, watch: {
    '$route.params.cat_id': function () {
      this.get_lists();
    }
  },
  methods: {
      table_row_clicked(item, index) {

          this.table_clicks++;
          if (this.table_clicks == 1) {
              this.table_clicks_timer = setTimeout(() => {
                  // this.result.push(event.type);
                  this.table_clicks = 0
              }, 500);
          } else if (this.table_clicks > 1) {
              clearTimeout(this.table_clicks_timer);
              this.goEditPerson(item)

          }

      },
    get_style(color) {
      return {
        myStyle: {
          backgroundColor: color
        }
      }
    },
    edit_item(item) {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.name = this.items[item.row_id].unitName;
      this.color = this.items[item.row_id].color;
      this.description = this.items[item.row_id].description;
      this.previewImage = this.items[item.row_id].image;
      this.status_form = this.items[item.row_id].id;
    },
    get_method_lists() {
      var self = this;

      const formData = new FormData();


      axios.post('GetPriceMethodTitles', formData, {}).then(function (response) {

        var content_data = response.data;

        if (content_data.statusCode == 0) {
          content_data.data.forEach((val) => {
            var obj = {label: val.title, value: val.id}

            self.method_list.push(obj);



          });
          if (self.$route.params.area_id == null) {
            self.get_lists();

          } else {
            self.get_listsByArea();

          }
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    edit_person_sale_method(method,user_id){
this.saleMethodModal = false;
      let self = this;
      const formData = new FormData();
      let url;
      url = "EditPersonMethod";
      formData.append('MethodId', method);
      formData.append('PersonId',user_id);
      // formData.append('AreaId', this.selected_area);
      axios.post(url, formData, {}).then((res) => {

        self.selected_method = '';
        self.selected_person = 0;

        self.get_lists();

        self.$root.modal_component.show_api_response_modals(res);

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    emptyList() {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.name = '';
      this.color = '';
      this.description = '';
      this.previewImage = '';
      this.status_form = 0;

      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    }, edit_sale_method(item) {
      this.selected_method = item.saleMethodId;
      this.selected_person = item.userId;
      this.saleMethodModal = true;

    },
    get_lists() {
      var self = this;


      const formData = new FormData();
        var url = "GetAllPersons";

        formData.append('IsVendor', false);
        formData.append('IsWorker', false);
        formData.append('IsCustomer', true);
        formData.append('IsActive', this.selected_status);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.items_customer = content_data.data.map((item, row_id) => {
            return {...item, row_id}

          });


        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_listsByArea() {
      var self = this;


      const formData = new FormData();

      var url = "GetUsers";

      formData.append("area_id", this.$route.params.area_id);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.items_customer = content_data.data.map((item, row_id) => {
// if(item.isCustomer){
            return {...item, row_id}

// }
          });

          self.items_customer = self.items_customer.filter(item => item.isCustomer);

          self.items_vendor = content_data.data.map((item, row_id) => {
            // console.log(item.isVendor);
            // if(item.isVendor){
            return {...item, row_id}

            // }
          });
          self.items_vendor = self.items_vendor.filter(item => item.isVendor);

          self.items_worker = content_data.data.map((item, row_id) => {
            // if(item.isCustomer){
            return {...item, row_id}

            // }
          });
          self.items_worker = self.items_worker.filter(item => item.isWorker);


        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    goEditPerson(item) {

      this.$router.push({path: '/dashboard/sale-orders/edit-customer/' + item.userId});

    },
    goToDocuments(item) {

      this.$router.push({path: '/dashboard/documents/person-list/' + item.userId});

    },
    goToAccountingReport(item) {

      this.$router.push({path: '/dashboard/users/user-accounting-report/' + item.userId});

    },
    goToPorsant(item) {
      this.$router.push({path: '/dashboard/users/user-porsant/' + item.userId});
    },
    delete_item_dialog(item) {
      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], this.confirm_delete_name);

      this.status_form = this.items[item.row_id].id;

    }, delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "DeletePerson";


      formData.append('id', this.status_form);

      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;

        self.get_lists();

      })
          .catch(function (error) {

            console.log(error);
          });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
  }
}

</script>
